export enum TextAreaEnum {
    Small = 'small',
    ExtendedHeight = 'extendedHeight',
    Medium = 'medium',
    Large = 'large',
    LargeResize = 'large-resize',
    FullWidth = 'fullWidth'
}
